import { useState } from "react";
import Confetti from "../../components/Confetti";

export default function ProLessonScreen({world,lessonIdx,progress,onComplete,onBack}){
  const lesson=world.lessons[lessonIdx];
  const qs=lesson.quiz||[];
  const PHASES=["Read","Example","Quiz"];
  const [phase,setPhase]=useState(0); // 0=read, 1=example, 2=quiz
  const [qIdx,setQIdx]=useState(0);
  const [answers,setAnswers]=useState([]);
  const [submitted,setSubmitted]=useState(false);
  const [showConf,setShowConf]=useState(false);
  const isDone=progress[`${world.id}-${lessonIdx}`];

  const curQ=qs[qIdx];
  const curAns=answers[qIdx]??null;
  const isLastQ=qIdx===qs.length-1;
  const score=qs.filter((q,i)=>answers[i]===q.a).length;

  function selectAns(i){if(submitted)return;setAnswers(p=>{const n=[...p];n[qIdx]=i;return n;});}
  function submitQ(){
    if(curAns===null)return;
    setSubmitted(true);
    if(isLastQ&&curAns===curQ.a){setShowConf(true);setTimeout(()=>setShowConf(false),2000);}
  }
  function nextQ(){setSubmitted(false);setQIdx(i=>i+1);}
  function finish(){onComplete(world.id,lessonIdx);onBack();}

  // Top bar
  const TopBar=()=>(
    <div style={{background:"#1e293b",borderBottom:`3px solid ${world.color}44`,padding:"12px 16px",
      display:"flex",alignItems:"center",gap:12,position:"sticky",top:0,zIndex:10}}>
      <button onClick={phase>0?()=>{setPhase(p=>p-1);setQIdx(0);setAnswers([]);setSubmitted(false);}:onBack}
        className="btn-bounce"
        style={{background:`${world.color}22`,border:`2px solid ${world.color}55`,borderRadius:12,
          padding:"6px 12px",fontSize:13,fontWeight:800,color:world.color,cursor:"pointer"}}>← Back</button>
      <div style={{flex:1}}>
        <div style={{fontSize:10,color:world.color,fontWeight:900,textTransform:"uppercase",letterSpacing:1.5}}>{world.label}</div>
        <div style={{fontSize:13,fontWeight:900,color:"#f1f5f9",lineHeight:1.1}}>{lesson.title}</div>
      </div>
      <div style={{fontSize:24}}>{world.emoji}</div>
    </div>
  );

  // Phase progress bar
  const PhaseTabs=()=>(
    <div style={{padding:"12px 16px 0"}}>
      <div style={{display:"flex",gap:4}}>
        {PHASES.map((p,i)=>(
          <div key={p} style={{flex:1,height:5,borderRadius:4,
            background:phase>i?world.color:phase===i?world.color+"88":"#334155",
            transition:"background 0.3s"}}/>
        ))}
      </div>
      <div style={{display:"flex",marginTop:4,marginBottom:12}}>
        {PHASES.map((p,i)=>(
          <div key={p} style={{flex:1,fontSize:9,fontWeight:800,textAlign:"center",
            color:phase>=i?world.color:"#475569",textTransform:"uppercase",letterSpacing:1}}>
            {i===0?"📖 Read":i===1?"💡 Example":"🧠 Quiz"}
          </div>
        ))}
      </div>
    </div>
  );

  return(
    <div style={{fontFamily:"Nunito",minHeight:"100vh",background:"#0f172a",color:"#f1f5f9",paddingBottom:40}}>
      {showConf&&<Confetti/>}
      <TopBar/>
      <PhaseTabs/>

      <div style={{padding:"0 16px"}}>

        {/* ── PHASE 0: READ ── */}
        {phase===0&&(
          <div style={{animation:"slideUp 0.35s"}}>
            {/* Key insight */}
            <div style={{background:`${world.color}18`,border:`2px solid ${world.color}44`,borderRadius:14,
              padding:"12px 14px",marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:800,color:world.color,lineHeight:1.5}}>{lesson.key}</div>
            </div>
            {/* Body */}
            <div style={{background:"#1e293b",borderRadius:16,padding:"16px",marginBottom:10,border:"1px solid #334155"}}>
              <p style={{fontSize:14,lineHeight:1.75,color:"#cbd5e1",margin:0}}>{lesson.body}</p>
            </div>
            {/* Sections */}
            {lesson.sections.map((s,i)=>(
              <div key={i} style={{background:"#1e293b",borderRadius:14,padding:"14px",marginBottom:10,
                border:`1px solid ${world.color}33`}}>
                <div style={{fontSize:13,fontWeight:900,color:world.color,marginBottom:7}}>{s.h}</div>
                <p style={{fontSize:13,lineHeight:1.7,color:"#94a3b8",margin:0}}>{s.p}</p>
              </div>
            ))}
            <button onClick={()=>setPhase(1)} className="btn-bounce"
              style={{width:"100%",marginTop:6,background:`linear-gradient(135deg,${world.color},${world.dark})`,
                border:"none",borderRadius:16,padding:"16px",fontSize:16,fontWeight:900,
                color:"#fff",cursor:"pointer",boxShadow:`0 6px 20px ${world.color}44`}}>
              See Real Example 💡
            </button>
          </div>
        )}

        {/* ── PHASE 1: EXAMPLE ── */}
        {phase===1&&lesson.example&&(
          <div style={{animation:"slideUp 0.35s"}}>
            <div style={{background:`linear-gradient(135deg,${world.color}22,${world.color}08)`,
              border:`2px solid ${world.color}55`,borderRadius:18,padding:"16px",marginBottom:12}}>
              <div style={{fontSize:11,fontWeight:900,color:world.color,textTransform:"uppercase",
                letterSpacing:1.5,marginBottom:6}}>📊 Real-World Example</div>
              <div style={{fontSize:16,fontWeight:900,color:"#f1f5f9",marginBottom:14,lineHeight:1.3}}>
                {lesson.example.title}
              </div>
              {/* Story — split on \n for paragraph breaks */}
              {lesson.example.story.split("\n").map((para,i)=>
                para.trim()?(
                  <p key={i} style={{fontSize:13,lineHeight:1.75,color:"#cbd5e1",margin:"0 0 10px",
                    background:para.startsWith("•")||para.match(/^(Step|Scenario|Option|Year|Month|Age|Property|Friend|Investor|Total|Taylor|Jordan|Alex|Casey|Dana|Morgan|Jamie|Riley|Sam|Jordan|Chris)/)?"#0f172a66":"transparent",
                    borderRadius:para.startsWith("•")||para.match(/^(Step|Scenario|Option|Year|Month|Age|Property|Friend|Investor|Total|Taylor|Jordan|Alex|Casey|Dana|Morgan|Jamie|Riley|Sam|Chris)/)? 8:0,
                    padding:para.startsWith("•")||para.match(/^(Step|Scenario|Option|Year|Month|Age|Property|Friend|Investor|Total|Taylor|Jordan|Alex|Casey|Dana|Morgan|Jamie|Riley|Sam|Chris)/)?"6px 10px":0}}>
                    {para}
                  </p>
                ):null
              )}
            </div>
            <button onClick={()=>setPhase(2)} className="btn-bounce"
              style={{width:"100%",background:`linear-gradient(135deg,${world.color},${world.dark})`,
                border:"none",borderRadius:16,padding:"16px",fontSize:16,fontWeight:900,
                color:"#fff",cursor:"pointer",boxShadow:`0 6px 20px ${world.color}44`}}>
              Take the Quiz 🧠
            </button>
          </div>
        )}

        {/* ── PHASE 2: QUIZ ── */}
        {phase===2&&qs.length>0&&(
          <div style={{animation:"slideUp 0.35s"}}>
            {/* Progress dots */}
            <div style={{marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                <div style={{fontSize:12,fontWeight:900,color:world.color,textTransform:"uppercase",letterSpacing:1}}>
                  Question {qIdx+1} of {qs.length}
                </div>
                <div style={{fontSize:12,fontWeight:800,color:"#475569"}}>
                  {answers.filter((a,i)=>a===qs[i].a).length}/{qs.length} correct
                </div>
              </div>
              <div style={{display:"flex",gap:5}}>
                {qs.map((_,i)=>{
                  const answered=answers[i]!==undefined;
                  const correct=answers[i]===qs[i].a;
                  return(
                    <div key={i} style={{flex:1,height:6,borderRadius:4,transition:"all 0.3s",
                      background:answered?(correct?world.color:"#ef4444"):i===qIdx?world.color+"55":"#334155",
                      border:i===qIdx?`1.5px solid ${world.color}`:"1.5px solid transparent"}}/>
                  );
                })}
              </div>
            </div>

            {/* Question card */}
            <div style={{background:"#1e293b",borderRadius:18,padding:"18px",marginBottom:12,
              border:`1px solid ${world.color}33`}}>
              <div style={{fontSize:15,fontWeight:800,color:"#f1f5f9",marginBottom:16,lineHeight:1.55}}>
                {curQ.q}
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {curQ.opts.map((o,i)=>{
                  let bg="#0f172a",border="1px solid #334155",clr="#94a3b8";
                  if(submitted){
                    if(i===curQ.a){bg=`${world.color}22`;border=`2px solid ${world.color}`;clr="#f1f5f9";}
                    else if(i===curAns&&i!==curQ.a){bg="#ef444422";border="2px solid #ef4444";clr="#fca5a5";}
                  } else if(curAns===i){bg=`${world.color}18`;border=`2px solid ${world.color}`;clr="#f1f5f9";}
                  return(
                    <button key={i} onClick={()=>selectAns(i)} className="btn-bounce"
                      style={{background:bg,border,borderRadius:12,padding:"12px 14px",
                        cursor:submitted?"default":"pointer",fontSize:13,fontWeight:700,
                        color:clr,textAlign:"left",transition:"all 0.2s",display:"flex",alignItems:"center",gap:10}}>
                      <span style={{fontSize:11,fontWeight:900,color:submitted&&i===curQ.a?world.color:clr,
                        background:submitted&&i===curQ.a?world.color+"22":"#ffffff0a",
                        borderRadius:6,padding:"2px 7px",flexShrink:0}}>
                        {["A","B","C","D"][i]}
                      </span>
                      {o}
                    </button>
                  );
                })}
              </div>
              {submitted&&(
                <div style={{marginTop:14,background:curAns===curQ.a?"#064e3b55":"#7f1d1d44",
                  border:`2px solid ${curAns===curQ.a?world.color:"#ef4444"}`,
                  borderRadius:14,padding:"12px 14px",animation:"slideUp 0.3s"}}>
                  <div style={{fontSize:13,fontWeight:800,lineHeight:1.5,
                    color:curAns===curQ.a?world.color:"#fca5a5"}}>
                    {curAns===curQ.a
                      ?`✓ ${curQ.praise}`
                      :`✗ Correct answer: "${curQ.opts[curQ.a]}"`}
                  </div>
                </div>
              )}
            </div>

            {/* Action button */}
            {!submitted?(
              <button onClick={submitQ} disabled={curAns===null} className="btn-bounce"
                style={{width:"100%",background:curAns===null?"#1e293b":`linear-gradient(135deg,${world.color},${world.dark})`,
                  border:`2px solid ${curAns===null?"#334155":world.color}`,borderRadius:16,padding:"15px",
                  fontSize:15,fontWeight:900,color:curAns===null?"#475569":"#fff",
                  cursor:curAns===null?"not-allowed":"pointer",transition:"all 0.25s",
                  boxShadow:curAns!==null?`0 6px 20px ${world.color}44`:"none"}}>
                Check Answer ✓
              </button>
            ):isLastQ?(
              /* Final scorecard */
              <div>
                <div style={{background:"#1e293b",borderRadius:16,padding:"18px",marginBottom:12,
                  border:`2px solid ${world.color}44`,textAlign:"center",animation:"pop 0.4s"}}>
                  <div style={{fontSize:40,marginBottom:8}}>
                    {score===qs.length?"🏆":score>=qs.length/2?"⭐":"📖"}
                  </div>
                  <div style={{fontSize:20,fontWeight:900,color:world.color,fontFamily:"Fredoka One"}}>
                    {score===qs.length?"Mastered!":score>=qs.length/2?"Solid Grasp!":"Review & Retry"}
                  </div>
                  <div style={{fontSize:14,color:"#64748b",fontWeight:700,marginTop:4}}>
                    {score} of {qs.length} correct
                  </div>
                  <div style={{display:"flex",gap:6,justifyContent:"center",marginTop:10}}>
                    {qs.map((q,i)=>(
                      <div key={i} style={{width:28,height:28,borderRadius:"50%",
                        background:answers[i]===q.a?world.color:"#ef444433",
                        border:`2px solid ${answers[i]===q.a?world.dark:"#ef4444"}`,
                        display:"flex",alignItems:"center",justifyContent:"center",
                        fontSize:12,fontWeight:900,color:"#fff"}}>
                        {answers[i]===q.a?"✓":"✗"}
                      </div>
                    ))}
                  </div>
                </div>
                <button onClick={finish} className="btn-bounce"
                  style={{width:"100%",background:`linear-gradient(135deg,${world.color},${world.dark})`,
                    border:"none",borderRadius:16,padding:"16px",fontSize:16,fontWeight:900,
                    color:"#fff",cursor:"pointer",boxShadow:`0 6px 20px ${world.color}44`,
                    animation:"pulse 1.5s infinite"}}>
                  Complete Lesson ✓
                </button>
              </div>
            ):(
              <button onClick={nextQ} className="btn-bounce"
                style={{width:"100%",background:`linear-gradient(135deg,${world.color},${world.dark})`,
                  border:"none",borderRadius:16,padding:"15px",fontSize:15,fontWeight:900,
                  color:"#fff",cursor:"pointer",boxShadow:`0 6px 20px ${world.color}44`}}>
                Next Question →
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
